import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Withdrawal in progress',
    youWithdraw: 'You withdraw',
    youReceive: 'Minimum amount',
    transactionId: 'Transaction ID',
    timeLeft: 'Time left',
    timeLeftValue: '{value} {unit} left',
    goToVaults: 'Go to Vaults',
    withdrawalWillTake:
      'Withdrawals take {value} {unit}. Only one withdrawal can be in-progress at a time.',
    withdrawalTime: 'Withdrawal time',
    cancelWithdrawal: 'Cancel withdrawal',
    network: 'Network',
  },
};
